import styled from 'styled-components';

export const Container = styled.div``;

export const Time = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
  & span {
    margin-left: 10px;
    margin-right: 10px;
  }
`;
